import { faBars, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { useNavigationDrawerValues } from 'components/navigation_drawer/navigation_drawer_store';
import { NavigationDrawerHeaderWrapper } from 'components/navigation_drawer/styled';

export function NavigationDrawerHeader() {
    const { isDrawerExpanded, toggleDrawerExpanded } = useNavigationDrawerValues(
        (state) => ({
            isDrawerExpanded: state.isDrawerExpanded,
            toggleDrawerExpanded: state.toggleDrawerExpanded,
        })
    );

    return (
        <NavigationDrawerHeaderWrapper
            $expanded={isDrawerExpanded}
            onClick={toggleDrawerExpanded}
        >
            <HoverIconButton
                size="1.8rem"
                className={isDrawerExpanded ? 'mr-20' : ''}
                aria-label={isDrawerExpanded ? 'Collapse' : 'Expand'}
                title={isDrawerExpanded ? 'Collapse' : 'Expand'}
                icon={isDrawerExpanded ? faTimes : faBars}
                hoverIcon={isDrawerExpanded ? faTimes : faBars}
                color="currentColor"
            />
        </NavigationDrawerHeaderWrapper>
    );
}
